import React from 'react';
import propTypes from 'prop-types';
import ListTabArrow from '~/Components/Global/Assets/Svgs/ListTabArrow';

const ListsDropDown = ({ current, valueRenderer, handleListDropDownClick, listsDropDownOpen }) => {
  return (
    <div className="list-title" id={current.id}>
      <ListTabArrow
        listsDropDownOpen={listsDropDownOpen}
        handleListDropDownClick={handleListDropDownClick}
      />
      {valueRenderer(current)}
    </div>
  );
};

ListsDropDown.propTypes = {
  current: propTypes.object,
  valueRenderer: propTypes.func,
  handleListDropDownClick: propTypes.func,
  listsDropDownOpen: propTypes.bool,
};

export default ListsDropDown;
